import { PermissionResource } from '@coin/shared/core/util-enums';

export const RBAF_PERMISSION_RESOURCES = [
  PermissionResource.Allocation,
  PermissionResource.AllocationHR,
  PermissionResource.PreviewAllocation,
  PermissionResource.AllocationSettings,
  PermissionResource.Emulation
];
